window.redoDebug = (enabled: boolean) => {
  sessionStorage.setItem("redo-debug", String(enabled));
};

export function log(...args: Parameters<typeof console.log>) {
  if (sessionStorage?.getItem("redo-debug") === "true") {
    console.log(...args);
  }
}
